import type { QueryClient } from "@tanstack/react-query";
import { fieldDefinitionKeys, chatKeys } from "@/queries/keys";

/** The chat variable catalog carries one entry per active field, so it follows the definitions. */
export function invalidateFieldDefinitions(queryClient: QueryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: fieldDefinitionKeys.all }),
    queryClient.invalidateQueries({ queryKey: chatKeys.variables() }),
  ]);
}
